import './style.css';
import Alpine from 'alpinejs';
import { registerSW } from 'virtual:pwa-register';

// Import Alpine components
import './components/globalFooter';
import './pages/login';
import './pages/dashboard';
import './pages/prepare';
import './pages/run';
import './pages/review';

// Import auth manager
import { auth } from './auth';

// Register service worker
registerSW({
  onNeedRefresh() {
    console.log('🔄 Nueva versión disponible');
  },
  onOfflineReady() {
    console.log('✅ App lista para funcionar offline');
  },
});

// Configure Alpine.js
declare global {
  interface Window {
    Alpine: typeof Alpine;
  }
}

window.Alpine = Alpine;

// Simple router with authentication
Alpine.data('app', () => ({
  currentPage: 'login',
  currentUser: null as any,
  
  init() {
    // Check if user is authenticated
    if (auth.isAuthenticated()) {
      this.currentUser = auth.getUser();
      const hash = window.location.hash.slice(1) || 'dashboard';
      this.currentPage = hash.split('/')[0] || 'dashboard';
    } else {
      this.currentPage = 'login';
      window.location.hash = '';
    }
    
    // Listen to hash changes
    window.addEventListener('hashchange', () => {
      if (!auth.isAuthenticated() && this.currentPage !== 'login') {
        this.currentPage = 'login';
        window.location.hash = '';
        return;
      }
      
      const newHash = window.location.hash.slice(1) || 'dashboard';
      this.currentPage = newHash.split('/')[0] || 'dashboard';
    });
  },
  
  navigate(page: string) {
    if (!auth.isAuthenticated() && page !== 'login') {
      this.currentPage = 'login';
      window.location.hash = '';
      return;
    }
    window.location.hash = page;
  },
  
  logout() {
    auth.logout();
    this.currentUser = null;
    this.currentPage = 'login';
    window.location.hash = '';
  }
}));

// Start Alpine
Alpine.start();

console.log('🚀 Meeting BPM Copilot v3 - Production Ready');
console.log('   Running on:', location.origin);

